import i18n from "i18next";
import LanguageDetector from "i18next-browser-languagedetector";
import { initReactI18next } from "react-i18next";

import deTranslation from "./locales/de/translation.json";
import deDETranslation from "./locales/de-DE/translation.json";
import enTranslation from "./locales/en/translation.json";
import enAUTranslation from "./locales/en-AU/translation.json";
import enCATranslation from "./locales/en-CA/translation.json";
import enGBTranslation from "./locales/en-GB/translation.json";
import esTranslation from "./locales/es/translation.json";
import esESTranslation from "./locales/es-ES/translation.json";
import fiTranslation from "./locales/fi/translation.json";
import frTranslation from "./locales/fr/translation.json";
import frCATranslation from "./locales/fr-CA/translation.json";
import frFRTranslation from "./locales/fr-FR/translation.json";
import isISTranslation from "./locales/is-IS/translation.json";
import itITTranslation from "./locales/it-IT/translation.json";
import jaJPTranslation from "./locales/ja-JP/translation.json";
import noTranslation from "./locales/no/translation.json";
import plPLTranslation from "./locales/pl-PL/translation.json";
import ptBRTranslation from "./locales/pt-BR/translation.json";
import ptPTTranslation from "./locales/pt-PT/translation.json";
import thTHTranslation from "./locales/th-TH/translation.json";
import zhSGTranslation from "./locales/zh-SG/translation.json";
import zhTWTranslation from "./locales/zh-TW/translation.json";

const resources = {
    en: { translation: enTranslation },
    "en-au": { translation: enAUTranslation },
    "en-ca": { translation: enCATranslation },
    "en-gb": { translation: enGBTranslation },
    de: { translation: deTranslation },
    "de-de": { translation: deDETranslation },
    es: { translation: esTranslation },
    "es-es": { translation: esESTranslation },
    fi: { translation: fiTranslation },
    fr: { translation: frTranslation },
    "fr-ca": { translation: frCATranslation },
    "fr-fr": { translation: frFRTranslation },
    "is-is": { translation: isISTranslation },
    "it-it": { translation: itITTranslation },
    "ja-jp": { translation: jaJPTranslation },
    no: { translation: noTranslation },
    "pl-pl": { translation: plPLTranslation },
    "pt-br": { translation: ptBRTranslation },
    "pt-pt": { translation: ptPTTranslation },
    "th-th": { translation: thTHTranslation },
    "zh-sg": { translation: zhSGTranslation },
    "zh-tw": { translation: zhTWTranslation },
};

i18n.use(LanguageDetector)
    .use(initReactI18next)
    .init({
        resources,
        debug: import.meta.env.MODE !== "production",
        fallbackLng: "en",
        supportedLngs: Object.keys(resources),
        lowerCaseLng: true,
        interpolation: {
            escapeValue: false,
        },
    });
export default i18n;
